var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg3(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#31B48C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1591 20.047C18.3551 16.267 21.0431 14.195 24.9631 14.195C29.1631 14.195 31.4031 16.575 31.4031 19.599C31.4031 22.147 29.8071 23.715 28.3231 24.219V24.331C30.3951 24.975 31.7671 26.655 31.7671 29.427C31.7671 32.759 29.4151 35.223 25.1311 35.223C21.0991 35.223 18.0471 33.207 17.8791 28.923H21.6871C21.7711 30.687 22.9471 31.947 25.0471 31.947C27.0071 31.947 28.0151 30.715 28.0151 29.091C28.0151 26.795 26.5591 25.955 23.6471 25.955H22.8351V22.735H23.6471C25.9431 22.735 27.6231 22.091 27.6231 20.075C27.6231 18.479 26.6431 17.527 24.8511 17.527C22.9471 17.527 22.1351 18.759 21.9951 20.047H18.1591Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.10d9b9603c673d5048e47c5480ce2a67.svg";
export { ForwardRef as ReactComponent };